export const toolTips = {
    "notifications":"Notificaciones",
    "profile": "Perfil",
    "filters": "Filtros",
    "refresh": "Refrescar",
    "clearFilters": "Limpiar filtros",
    "create": "Crear",
    "edit": "Editar",
    "delete": "Eliminar",
    "seeActions": "Ver acciones",
    "import": "Importar",
    "chart": "Histograma",
    "expand" : "Expandir",
    "collapse" : "Contraer",
    "supervisor": "Supervisores",
    "seeEvidences": "Evidencias"
}